.detail {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.title,
.sectionTitle {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-0);
}

.section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.list,
.text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: var(--font-size-md);
  color: var(--color-text-1);
  overflow-wrap: anywhere;
}

.list {
  padding-left: 16px;
  list-style: disc;
}

.subtitle {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-0);
}
